import { render, staticRenderFns } from "./StepBasicEditor.vue?vue&type=template&id=3081e78e&scoped=true"
import script from "./StepBasicEditor.vue?vue&type=script&lang=js"
export * from "./StepBasicEditor.vue?vue&type=script&lang=js"
import style0 from "./StepBasicEditor.vue?vue&type=style&index=0&id=3081e78e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081e78e",
  null
  
)

export default component.exports